import OverlaySheet from 'components/OverlaySheet';

/**
 * Confirmação de uma ação do administrativo, com o texto vindo de quem chama.
 *
 * Nasceu dentro de `pages/Admin/Servicos/` e subiu para cá quando o catálogo de planos passou a
 * precisar da mesma coisa. O que é compartilhado é o esqueleto — overlay, área de erro, par de
 * botões, estado "processando" que desabilita o confirmar. O texto **não** é: cada catálogo explica
 * a própria consequência, e foi justamente essa frase que fez o diálogo de serviços valer a pena
 * (dizer que soft delete não apaga histórico, no momento em que a pessoa decide).
 *
 * Por isso o corpo entra como `children` e não como prop de string: as duas telas precisam de
 * <strong> e de contagens no meio da frase.
 *
 * `destrutivo` pinta o botão de vermelho e é o único traço de significado que o componente carrega.
 */
export default function DialogoConfirmacao({
  aberto,
  titulo,
  destrutivo = false,
  rotuloConfirmar,
  processando,
  erro,
  onFechar,
  onConfirmar,
  children,
}) {
  return (
    <OverlaySheet aberto={aberto} onFechar={onFechar} titulo={titulo} larguraDesktop="md:w-[30rem]">
      {children}

      {erro && (
        <p role="alert" className="mt-3 rounded-xl border-caixa border-error/30 bg-error/10 p-3 text-sm text-error">
          {erro}
        </p>
      )}

      <div className="mt-5 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
        <button type="button" onClick={onFechar} className="btn btn-outline justify-center">
          Cancelar
        </button>
        <button
          type="button"
          onClick={onConfirmar}
          disabled={processando}
          className={`btn justify-center ${
            destrutivo ? 'btn bg-error text-white hover:bg-error/90 focus:ring-error' : 'btn-primary'
          }`}
        >
          {processando ? 'Aguarde…' : rotuloConfirmar}
        </button>
      </div>
    </OverlaySheet>
  );
}
